import { useState, useEffect } from 'react';
import { useAlert } from '../functions/useAlert';
import { checkMicrosoftConnectionStatus, getMicrosoftOAuthUrl } from '../services/microsoft.service';
import { checkZoomStatus } from '../services/connectors.service';

interface SchedulerOAuthState {
  isMicrosoftConnected: boolean;
  isZoomEnabled: boolean;
  handleConnectMicrosoft: () => Promise<void>;
}

export const useSchedulerOAuth = (open: boolean, userId?: string): SchedulerOAuthState => {
  const [setAlert] = useAlert();
  const [isMicrosoftConnected, setIsMicrosoftConnected] = useState(true);
  const [isZoomEnabled, setIsZoomEnabled] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('outlook_error') === 'wrong_organisation') {
      setAlert(
        'This Microsoft account belongs to a different organisation. Please sign in with your company Microsoft account.',
        'error',
      );
      window.history.replaceState({}, '', window.location.pathname);
    }
    if (params.get('outlook_connected') === 'true') {
      setIsMicrosoftConnected(true);
      window.history.replaceState({}, '', window.location.pathname);
    }
    checkMicrosoftConnectionStatus()
      .then((res: any) => setIsMicrosoftConnected(res.isConnected === true))
      .catch(() => setIsMicrosoftConnected(false));
  }, []);

  useEffect(() => {
    if (!open || !userId) return;
    checkZoomStatus(userId)
      .then((res: any) => setIsZoomEnabled(res.connected === true))
      .catch(() => setIsZoomEnabled(false));
  }, [open, userId]);

  const handleConnectMicrosoft = async () => {
    try {
      const res: any = await getMicrosoftOAuthUrl(window.location.href);
      window.location.href = res.url;
    } catch {
      setAlert(
        'Failed to start Microsoft sign-in. Ensure Microsoft 365 is connected in Organisation Settings.',
        'error',
      );
    }
  };

  return { isMicrosoftConnected, isZoomEnabled, handleConnectMicrosoft };
};
